import {
  useCrearLogro,
  useEditarLogro,
  useListarLogros,
  useEliminarLogro,
} from "../../../../Hooks/Admin";
import { CustomForm } from "../../../../Components/Admin/CustomForm";
import { CustomTable } from "../../../../Components/Admin/CustomTable";
import {
  camposFormulario,
  columns,
  formatData,
  camposFilter,
} from "./camposFormulario";
import { useEffect, useState } from "react";

export const LogrosForm = () => {
  const [campos, setCampos] = useState();
  const [tiposLogros, setTiposLogros] = useState(null);
  const initialValues = {
    tilo_id: 1,
  };

  useEffect(() => {
    setTiposLogros([
      {
        label: "Medalla",
        value: 1,
      },
      {
        label: "Torneo",
        value: 2,
      },
      {
        label: "Aventura",
        value: 3,
      },
    ]);
  }, []);

  useEffect(() => {
    setCampos(camposFormulario(tiposLogros));
  }, [tiposLogros]);

  return (
    <>
      {campos && (
        <CustomForm
          camposFormulario={campos}
          querySubmit={useCrearLogro}
          initialValues={initialValues}
        />
      )}
    </>
  );
};

export const LogrosEditar = () => {
  const [campos, setCampos] = useState();
  const [tiposLogros, setTiposLogros] = useState(null);

  // Hook para eliminar logros
  const eliminarLogroQuery = useEliminarLogro();
  
  const eliminarLogro = async (row) => {
    try {
      await eliminarLogroQuery.mutateAsync({ id: row.id });
      // La notificación de éxito se maneja en el hook
    } catch (error) {
      // Los errores se manejan en el hook
    }
  };

  useEffect(() => {
    setTiposLogros([
      {
        label: "Medalla",
        value: 1,
      },
      {
        label: "Torneo",
        value: 2,
      },
      {
        label: "Aventura",
        value: 3,
      },
    ]);
  }, []);

  useEffect(() => {
    setCampos(camposFormulario(tiposLogros));
  }, [tiposLogros]);

  return (
    <CustomTable
      camposFilter={camposFilter(tiposLogros)}
      camposFormularioModal={campos}
      queryListar={useListarLogros}
      queryEditar={useEditarLogro}
      formatData={formatData}
      columns={columns}
      editable={true}
      imagen={true}
      camposAgregar={camposFormulario(tiposLogros)}
      queryCrear={useCrearLogro}
      canDelete={true}
      queryBorrarFila={useEliminarLogro} // Hook de eliminación actualizado
    />
  );
};
